(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["achaiah-next-session"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-session-countdown]');
    if (!section) return;
    const source = section.querySelector('[data-session-events]');
    const events = JSON.parse(source.textContent).filter((event) => event.date).sort((a, b) => new Date(a.date) - new Date(b.date));
    const next = events.find((event) => new Date(event.date).getTime() > Date.now());
    if (!next) {
      section.hidden = true;
      return;
    }
    section.querySelector('[data-session-date]').textContent = next.label;
    section.querySelector('[data-session-link]').href = next.url;
    const update = () => {
      const remaining = Math.max(0, new Date(next.date).getTime() - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      section.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      section.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      section.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      section.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
      if (remaining === 0) window.location.reload();
    };
    update();
    window.setInterval(update, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
